module.exports = __webpack_public_path__ + "static/media/bag_with_books.5fae0c32.png";